// extracted by css-extract-rspack-plugin
export default {"fallback":"rRSsBxsrvcsjv_x5","title":"TLbo4QmiizstzfAm","description":"bPPoowIfSN0K123o"};